__turbopack_context__.v({
  "fullBleedImageWrapper": "OrderConfirmationContent-module__O11AIa__fullBleedImageWrapper",
  "nextStepsIconContainer": "OrderConfirmationContent-module__O11AIa__nextStepsIconContainer",
  "perksContent": "OrderConfirmationContent-module__O11AIa__perksContent",
  "perksImage": "OrderConfirmationContent-module__O11AIa__perksImage",
  "perksSection": "OrderConfirmationContent-module__O11AIa__perksSection",
  "welcomeContainer": "OrderConfirmationContent-module__O11AIa__welcomeContainer",
  "welcomeContent": "OrderConfirmationContent-module__O11AIa__welcomeContent",
  "welcomeContentOuter": "OrderConfirmationContent-module__O11AIa__welcomeContentOuter",
  "welcomeImageContainer": "OrderConfirmationContent-module__O11AIa__welcomeImageContainer",
  "welcomeImageText": "OrderConfirmationContent-module__O11AIa__welcomeImageText",
  "welcomeImageWrapper": "OrderConfirmationContent-module__O11AIa__welcomeImageWrapper",
  "whatsNextContainer": "OrderConfirmationContent-module__O11AIa__whatsNextContainer",
  "whatsNextItemContainer": "OrderConfirmationContent-module__O11AIa__whatsNextItemContainer",
  "whatsNextTextSectionContainer": "OrderConfirmationContent-module__O11AIa__whatsNextTextSectionContainer",
  "winWithFriends": "OrderConfirmationContent-module__O11AIa__winWithFriends",
  "winWithFriendsAvatar": "OrderConfirmationContent-module__O11AIa__winWithFriendsAvatar",
  "winWithFriendsContainer": "OrderConfirmationContent-module__O11AIa__winWithFriendsContainer",
  "winWithFriendsLink": "OrderConfirmationContent-module__O11AIa__winWithFriendsLink",
  "winWithFriendsSpeechBubble": "OrderConfirmationContent-module__O11AIa__winWithFriendsSpeechBubble",
});
